module.exports = __webpack_public_path__ + "static/media/37-2.d6fc0104.mp3";